const ACTIONS = {
	AUTH : {
		IS_AUTH : "AUTH_IS_AUTH"
	},

	MAIN : {
		SET_VISIT       : "MAIN_SET_VISIT",
		GET_FACTORS     : "MAIN_GET_FACTORS",
		TOOGLE_DOP_SHOW : "MAIN_TOOGLE_DOP_SHOW"
	},

	MAIN_LIVE : {
		RECEIVE_PROPS : "MAIN_LIVE_RECEIVE_PROPS"
	},

	MAIN_LIVE_SOON : {
		RECEIVE_PROPS : "MAIN_LIVE_SOON_RECEIVE_PROPS"
	},

	LINE : {
		GET_POPULAR          : "LINE_GET_POPULAR",
		GET_LINE             : "LINE_GET_LINE",
		GET_LEAGUES_BY_SPORT : "LINE_GET_LEAGUES_BY_SPORT"
	},

	NEWS : {
		RECEIVE_PROPS   : "NEWS_RECEIVE_PROPS",
		TOGGLE_FETCHING : "NEWS_TOGGLE_FETCHING"
	},

	ONECLICK : {
		TOGGLE           : "ONECLICK_TOGGLE",
		CHANGE_AMOUNT    : "ONECLICK_CHANGE_AMOUNT",
		START_PROCESSING : "ONECLICK_START_PROCESSING",
		STOP_PROCESSING  : "ONECLICK_STOP_PROCESSING",
	},

	COUPON : {
		RECEIVE_PROPS   : "COUPON_RECEIVE_PROPS",
		UPDATE          : "COUPON_UPDATE",
		CHANGE_LIVE_OPT : "COUPON_CHANGE_LIVE_OPT"
	},

	VIEWED_NEWS : {
		ADD    : "VIEWED_NEWS_ADD",
		REMOVE : "VIEWED_NEWS_REMOVE"
	},

	FAVORITE_SPORTS : {
		TOGGLE : "FAVORITE_SPORTS_TOGGLE"
	},

	FAVORITES : {
		TOGGLE : "FAVORITES_TOGGLE",
		DELETE : "FAVORITES_DELETE",
		UPDATE : "FAVORITES_UPDATE"
	},

	VIDEO_MODAL : {
		UPDATE : "VIDEO_MODAL_UPDATE"
	},

	UNVIEWED_NEWS : {
		UPDATE_COUNT : "UNVIEWED_NEWS_UPDATE_COUNT",
		GET          : "UNVIEWED_NEWS_GET"
	},

	USER : {
		LOGIN           : "USER_LOGIN",
		LOGOUT          : "USER_LOGOUT",
		GET_INFO        : "USER_GET_INFO",
		GET_CASH        : "USER_GET_CASH",
		TOGGLE_FETCHING : "USER_TOGGLE_FETCHING"
	},

	BET : {
		GET_HISTORY     : "BET_GET_HISTORY",
		TOGGLE_FETCHING : "BET_TOGGLE_FETCHING"
	},

	PAYMENTS : {
		GET_HISTORY : "PAYMENTS_GET_HISTORY",
		CANCEL      : "PAYMENTS_CANCEL"
	},

	FILTER : {
		DATA  : "FILTER_DATA",
		CLEAR : "FILTER_CLEAR"
	},

	TOP_TOURNEYS : {
		GET : "TOP_TORNEYS_GET"
	},

	RESULT : {
		GET_LIVE      : "RESULT_GET_LIVE",
		GET_LINE      : "RESULT_GET_LINE",
		FETCHING_LINE : "RESULT_FETCHING_LINE",
	},

	TRACKER : {
		SET    : "TRACKER_SET",
		TOGGLE : "TRACKER_TOGGLE"
	}
};

export default ACTIONS;


// WEBPACK FOOTER //
// ./src/app/constants/actions.js